/* eslint-disable */
import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  Long: any;
  Upload: any;
};

export type Announcement = {
  __typename?: 'Announcement';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  redirectURL: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AnnouncementEntity = {
  __typename?: 'AnnouncementEntity';
  attributes?: Maybe<Announcement>;
  id?: Maybe<Scalars['ID']>;
};

export type AnnouncementEntityResponse = {
  __typename?: 'AnnouncementEntityResponse';
  data?: Maybe<AnnouncementEntity>;
};

export type AnnouncementInput = {
  content?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  redirectURL?: InputMaybe<Scalars['String']>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentSectionEventPage = {
  __typename?: 'ComponentSectionEventPage';
  description?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentSectionFaqs = {
  __typename?: 'ComponentSectionFaqs';
  answer?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
};

export type ComponentSectionFaqsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionFaqsFiltersInput>>>;
  answer?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionFaqsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionFaqsFiltersInput>>>;
  question?: InputMaybe<StringFilterInput>;
};

export type ComponentSectionFaqsInput = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<Scalars['String']>;
};

export type ComponentSectionFeature = {
  __typename?: 'ComponentSectionFeature';
  FreeCoachingActivitiesAndWorksheets: Scalars['Boolean'];
  FreeTrial: Scalars['Boolean'];
  LockInPeriodInMonths: Scalars['Int'];
  ManagerSyncUpCall: Enum_Componentsectionfeature_Managersyncupcall;
  PulseSurvey: Enum_Componentsectionfeature_Pulsesurvey;
  id: Scalars['ID'];
};

export type ComponentSectionFeatureFiltersInput = {
  FreeCoachingActivitiesAndWorksheets?: InputMaybe<BooleanFilterInput>;
  FreeTrial?: InputMaybe<BooleanFilterInput>;
  LockInPeriodInMonths?: InputMaybe<IntFilterInput>;
  ManagerSyncUpCall?: InputMaybe<StringFilterInput>;
  PulseSurvey?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSectionFeatureFiltersInput>>>;
  not?: InputMaybe<ComponentSectionFeatureFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionFeatureFiltersInput>>>;
};

export type ComponentSectionFeatureInput = {
  FreeCoachingActivitiesAndWorksheets?: InputMaybe<Scalars['Boolean']>;
  FreeTrial?: InputMaybe<Scalars['Boolean']>;
  LockInPeriodInMonths?: InputMaybe<Scalars['Int']>;
  ManagerSyncUpCall?: InputMaybe<Enum_Componentsectionfeature_Managersyncupcall>;
  PulseSurvey?: InputMaybe<Enum_Componentsectionfeature_Pulsesurvey>;
  id?: InputMaybe<Scalars['ID']>;
};

export type ComponentSectionMember = {
  __typename?: 'ComponentSectionMember';
  certificates?: Maybe<Array<Maybe<ComponentSharedCertificate>>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  photo: UploadFileEntityResponse;
  socials?: Maybe<ComponentSectionSocial>;
  specialty?: Maybe<ComponentSectionSpecialization>;
  title: Scalars['String'];
};


export type ComponentSectionMemberCertificatesArgs = {
  filters?: InputMaybe<ComponentSharedCertificateFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ComponentSectionMemberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionMemberFiltersInput>>>;
  certificates?: InputMaybe<ComponentSharedCertificateFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionMemberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionMemberFiltersInput>>>;
  socials?: InputMaybe<ComponentSectionSocialFiltersInput>;
  specialty?: InputMaybe<ComponentSectionSpecializationFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSectionMemberInput = {
  certificates?: InputMaybe<Array<InputMaybe<ComponentSharedCertificateInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['ID']>;
  socials?: InputMaybe<ComponentSectionSocialInput>;
  specialty?: InputMaybe<ComponentSectionSpecializationInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentSectionPlan = {
  __typename?: 'ComponentSectionPlan';
  billingCycle: Enum_Componentsectionplan_Billingcycle;
  features?: Maybe<ComponentSectionFeature>;
  id: Scalars['ID'];
  name: Scalars['String'];
  price: Scalars['Float'];
  recommend?: Maybe<Scalars['Boolean']>;
};

export type ComponentSectionPlanFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionPlanFiltersInput>>>;
  billingCycle?: InputMaybe<StringFilterInput>;
  features?: InputMaybe<ComponentSectionFeatureFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionPlanFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionPlanFiltersInput>>>;
  price?: InputMaybe<FloatFilterInput>;
  recommend?: InputMaybe<BooleanFilterInput>;
};

export type ComponentSectionPlanInput = {
  billingCycle?: InputMaybe<Enum_Componentsectionplan_Billingcycle>;
  features?: InputMaybe<ComponentSectionFeatureInput>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  recommend?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentSectionResourcePage = {
  __typename?: 'ComponentSectionResourcePage';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  price?: Maybe<Scalars['Float']>;
  redirectURL?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']>;
};

export type ComponentSectionResourcePageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionResourcePageFiltersInput>>>;
  category?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionResourcePageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionResourcePageFiltersInput>>>;
  price?: InputMaybe<FloatFilterInput>;
  redirectURL?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSectionResourcePageInput = {
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<Scalars['Float']>;
  redirectURL?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ComponentSectionServices = {
  __typename?: 'ComponentSectionServices';
  cover: UploadFileEntityResponse;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  learnMoreLink?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ComponentSectionServicesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionServicesFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  learnMoreLink?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionServicesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionServicesFiltersInput>>>;
};

export type ComponentSectionServicesInput = {
  cover?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  learnMoreLink?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ComponentSectionSocial = {
  __typename?: 'ComponentSectionSocial';
  id: Scalars['ID'];
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

export type ComponentSectionSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionSocialFiltersInput>>>;
  linkedin?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionSocialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionSocialFiltersInput>>>;
  twitter?: InputMaybe<StringFilterInput>;
};

export type ComponentSectionSocialInput = {
  id?: InputMaybe<Scalars['ID']>;
  linkedin?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

export type ComponentSectionSpecialization = {
  __typename?: 'ComponentSectionSpecialization';
  id: Scalars['ID'];
  major: Scalars['String'];
  minor?: Maybe<Scalars['String']>;
};

export type ComponentSectionSpecializationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionSpecializationFiltersInput>>>;
  major?: InputMaybe<StringFilterInput>;
  minor?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionSpecializationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionSpecializationFiltersInput>>>;
};

export type ComponentSectionSpecializationInput = {
  id?: InputMaybe<Scalars['ID']>;
  major?: InputMaybe<Scalars['String']>;
  minor?: InputMaybe<Scalars['String']>;
};

export type ComponentSectionTestimonial = {
  __typename?: 'ComponentSectionTestimonial';
  author: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  feedback: Scalars['String'];
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  picture: UploadFileEntityResponse;
  rating: Scalars['Int'];
};

export type ComponentSectionTestimonialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSectionTestimonialFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  company?: InputMaybe<StringFilterInput>;
  feedback?: InputMaybe<StringFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSectionTestimonialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSectionTestimonialFiltersInput>>>;
  rating?: InputMaybe<IntFilterInput>;
};

export type ComponentSectionTestimonialInput = {
  author?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  feedback?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['ID']>;
  rating?: InputMaybe<Scalars['Int']>;
};

export type ComponentSharedCertificate = {
  __typename?: 'ComponentSharedCertificate';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<UploadFileEntityResponse>;
  name: Scalars['String'];
};

export type ComponentSharedCertificateFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedCertificateFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedCertificateFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedCertificateFiltersInput>>>;
};

export type ComponentSharedCertificateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export enum Enum_Componentsectionfeature_Managersyncupcall {
  One = 'one',
  Recurring = 'recurring'
}

export enum Enum_Componentsectionfeature_Pulsesurvey {
  PulseSurveyOrEndQuarterFeedback = 'PulseSurveyOrEndQuarterFeedback',
  PulseSurveyOrQuarterlyFeedback = 'PulseSurveyOrQuarterlyFeedback',
  WithinTheOrg = 'WithinTheOrg'
}

export enum Enum_Componentsectionplan_Billingcycle {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly'
}

export type Event = {
  __typename?: 'Event';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  eventDate?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  registerURL?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  youtubeURL?: Maybe<Scalars['String']>;
};

export type EventEntity = {
  __typename?: 'EventEntity';
  attributes?: Maybe<Event>;
  id?: Maybe<Scalars['ID']>;
};

export type EventEntityResponse = {
  __typename?: 'EventEntityResponse';
  data?: Maybe<EventEntity>;
};

export type EventEntityResponseCollection = {
  __typename?: 'EventEntityResponseCollection';
  data: Array<EventEntity>;
  meta: ResponseCollectionMeta;
};

export type EventFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  eventDate?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<EventFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EventFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  registerURL?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  youtubeURL?: InputMaybe<StringFilterInput>;
};

export type EventInput = {
  description?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['DateTime']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  registerURL?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  youtubeURL?: InputMaybe<Scalars['String']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type GenericMorph = Announcement | ComponentSectionEventPage | ComponentSectionFaqs | ComponentSectionFeature | ComponentSectionMember | ComponentSectionPlan | ComponentSectionResourcePage | ComponentSectionServices | ComponentSectionSocial | ComponentSectionSpecialization | ComponentSectionTestimonial | ComponentSharedCertificate | Event | I18NLocale | Landing | Post | Pricing | Request | ResourcePage | Subscriber | Team | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type Landing = {
  __typename?: 'Landing';
  createdAt?: Maybe<Scalars['DateTime']>;
  faqs?: Maybe<Array<Maybe<ComponentSectionFaqs>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  services?: Maybe<Array<Maybe<ComponentSectionServices>>>;
  testimonials?: Maybe<Array<Maybe<ComponentSectionTestimonial>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type LandingFaqsArgs = {
  filters?: InputMaybe<ComponentSectionFaqsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type LandingServicesArgs = {
  filters?: InputMaybe<ComponentSectionServicesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type LandingTestimonialsArgs = {
  filters?: InputMaybe<ComponentSectionTestimonialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingEntity = {
  __typename?: 'LandingEntity';
  attributes?: Maybe<Landing>;
  id?: Maybe<Scalars['ID']>;
};

export type LandingEntityResponse = {
  __typename?: 'LandingEntityResponse';
  data?: Maybe<LandingEntity>;
};

export type LandingInput = {
  faqs?: InputMaybe<Array<InputMaybe<ComponentSectionFaqsInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  services?: InputMaybe<Array<InputMaybe<ComponentSectionServicesInput>>>;
  testimonials?: InputMaybe<Array<InputMaybe<ComponentSectionTestimonialInput>>>;
};

export type LongFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  contains?: InputMaybe<Scalars['Long']>;
  containsi?: InputMaybe<Scalars['Long']>;
  endsWith?: InputMaybe<Scalars['Long']>;
  eq?: InputMaybe<Scalars['Long']>;
  eqi?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  ne?: InputMaybe<Scalars['Long']>;
  not?: InputMaybe<LongFilterInput>;
  notContains?: InputMaybe<Scalars['Long']>;
  notContainsi?: InputMaybe<Scalars['Long']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  startsWith?: InputMaybe<Scalars['Long']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createEvent?: Maybe<EventEntityResponse>;
  createPost?: Maybe<PostEntityResponse>;
  createRequest?: Maybe<RequestEntityResponse>;
  createSubscriber?: Maybe<SubscriberEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteAnnouncement?: Maybe<AnnouncementEntityResponse>;
  deleteEvent?: Maybe<EventEntityResponse>;
  deleteLanding?: Maybe<LandingEntityResponse>;
  deletePost?: Maybe<PostEntityResponse>;
  deletePricing?: Maybe<PricingEntityResponse>;
  deleteRequest?: Maybe<RequestEntityResponse>;
  deleteResourcePage?: Maybe<ResourcePageEntityResponse>;
  deleteSubscriber?: Maybe<SubscriberEntityResponse>;
  deleteTeam?: Maybe<TeamEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateAnnouncement?: Maybe<AnnouncementEntityResponse>;
  updateEvent?: Maybe<EventEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateLanding?: Maybe<LandingEntityResponse>;
  updatePost?: Maybe<PostEntityResponse>;
  updatePricing?: Maybe<PricingEntityResponse>;
  updateRequest?: Maybe<RequestEntityResponse>;
  updateResourcePage?: Maybe<ResourcePageEntityResponse>;
  updateSubscriber?: Maybe<SubscriberEntityResponse>;
  updateTeam?: Maybe<TeamEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationCreateEventArgs = {
  data: EventInput;
};


export type MutationCreatePostArgs = {
  data: PostInput;
};


export type MutationCreateRequestArgs = {
  data: RequestInput;
};


export type MutationCreateSubscriberArgs = {
  data: SubscriberInput;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePostArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRequestArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSubscriberArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateAnnouncementArgs = {
  data: AnnouncementInput;
};


export type MutationUpdateEventArgs = {
  data: EventInput;
  id: Scalars['ID'];
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateLandingArgs = {
  data: LandingInput;
};


export type MutationUpdatePostArgs = {
  data: PostInput;
  id: Scalars['ID'];
};


export type MutationUpdatePricingArgs = {
  data: PricingInput;
};


export type MutationUpdateRequestArgs = {
  data: RequestInput;
  id: Scalars['ID'];
};


export type MutationUpdateResourcePageArgs = {
  data: ResourcePageInput;
};


export type MutationUpdateSubscriberArgs = {
  data: SubscriberInput;
  id: Scalars['ID'];
};


export type MutationUpdateTeamArgs = {
  data: TeamInput;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type Post = {
  __typename?: 'Post';
  author?: Maybe<UsersPermissionsUserEntityResponse>;
  content: Scalars['String'];
  cover: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  estimatedReadingTime: Scalars['Int'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  views: Scalars['Long'];
};

export type PostEntity = {
  __typename?: 'PostEntity';
  attributes?: Maybe<Post>;
  id?: Maybe<Scalars['ID']>;
};

export type PostEntityResponse = {
  __typename?: 'PostEntityResponse';
  data?: Maybe<PostEntity>;
};

export type PostEntityResponseCollection = {
  __typename?: 'PostEntityResponseCollection';
  data: Array<PostEntity>;
  meta: ResponseCollectionMeta;
};

export type PostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  author?: InputMaybe<UsersPermissionsUserFiltersInput>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  estimatedReadingTime?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PostFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  views?: InputMaybe<LongFilterInput>;
};

export type PostInput = {
  author?: InputMaybe<Scalars['ID']>;
  content?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  estimatedReadingTime?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  views?: InputMaybe<Scalars['Long']>;
};

export type PostRelationResponseCollection = {
  __typename?: 'PostRelationResponseCollection';
  data: Array<PostEntity>;
};

export type Pricing = {
  __typename?: 'Pricing';
  createdAt?: Maybe<Scalars['DateTime']>;
  plans?: Maybe<Array<Maybe<ComponentSectionPlan>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PricingPlansArgs = {
  filters?: InputMaybe<ComponentSectionPlanFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PricingEntity = {
  __typename?: 'PricingEntity';
  attributes?: Maybe<Pricing>;
  id?: Maybe<Scalars['ID']>;
};

export type PricingEntityResponse = {
  __typename?: 'PricingEntityResponse';
  data?: Maybe<PricingEntity>;
};

export type PricingInput = {
  plans?: InputMaybe<Array<InputMaybe<ComponentSectionPlanInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  announcement?: Maybe<AnnouncementEntityResponse>;
  event?: Maybe<EventEntityResponse>;
  events?: Maybe<EventEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  landing?: Maybe<LandingEntityResponse>;
  me?: Maybe<UsersPermissionsMe>;
  post?: Maybe<PostEntityResponse>;
  posts?: Maybe<PostEntityResponseCollection>;
  pricing?: Maybe<PricingEntityResponse>;
  request?: Maybe<RequestEntityResponse>;
  requests?: Maybe<RequestEntityResponseCollection>;
  resourcePage?: Maybe<ResourcePageEntityResponse>;
  subscriber?: Maybe<SubscriberEntityResponse>;
  subscribers?: Maybe<SubscriberEntityResponseCollection>;
  team?: Maybe<TeamEntityResponse>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryAnnouncementArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEventsArgs = {
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryLandingArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryPostArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPostsArgs = {
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPricingArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryRequestArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRequestsArgs = {
  filters?: InputMaybe<RequestFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryResourcePageArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QuerySubscriberArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QuerySubscribersArgs = {
  filters?: InputMaybe<SubscriberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTeamArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Request = {
  __typename?: 'Request';
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['JSON']>;
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestEntity = {
  __typename?: 'RequestEntity';
  attributes?: Maybe<Request>;
  id?: Maybe<Scalars['ID']>;
};

export type RequestEntityResponse = {
  __typename?: 'RequestEntityResponse';
  data?: Maybe<RequestEntity>;
};

export type RequestEntityResponseCollection = {
  __typename?: 'RequestEntityResponseCollection';
  data: Array<RequestEntity>;
  meta: ResponseCollectionMeta;
};

export type RequestFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<RequestFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  details?: InputMaybe<JsonFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RequestFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<RequestFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type RequestInput = {
  details?: InputMaybe<Scalars['JSON']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourcePage = {
  __typename?: 'ResourcePage';
  createdAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  resources?: Maybe<Array<Maybe<ComponentSectionResourcePage>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ResourcePageResourcesArgs = {
  filters?: InputMaybe<ComponentSectionResourcePageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ResourcePageEntity = {
  __typename?: 'ResourcePageEntity';
  attributes?: Maybe<ResourcePage>;
  id?: Maybe<Scalars['ID']>;
};

export type ResourcePageEntityResponse = {
  __typename?: 'ResourcePageEntityResponse';
  data?: Maybe<ResourcePageEntity>;
};

export type ResourcePageInput = {
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  resources?: InputMaybe<Array<InputMaybe<ComponentSectionResourcePageInput>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscriber = {
  __typename?: 'Subscriber';
  company?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['JSON']>;
  email: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriberEntity = {
  __typename?: 'SubscriberEntity';
  attributes?: Maybe<Subscriber>;
  id?: Maybe<Scalars['ID']>;
};

export type SubscriberEntityResponse = {
  __typename?: 'SubscriberEntityResponse';
  data?: Maybe<SubscriberEntity>;
};

export type SubscriberEntityResponseCollection = {
  __typename?: 'SubscriberEntityResponseCollection';
  data: Array<SubscriberEntity>;
  meta: ResponseCollectionMeta;
};

export type SubscriberFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<SubscriberFiltersInput>>>;
  company?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  details?: InputMaybe<JsonFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SubscriberFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<SubscriberFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type SubscriberInput = {
  company?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  email?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Team = {
  __typename?: 'Team';
  createdAt?: Maybe<Scalars['DateTime']>;
  highlight?: Maybe<ComponentSectionMember>;
  members?: Maybe<Array<Maybe<ComponentSectionMember>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TeamMembersArgs = {
  filters?: InputMaybe<ComponentSectionMemberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeamEntity = {
  __typename?: 'TeamEntity';
  attributes?: Maybe<Team>;
  id?: Maybe<Scalars['ID']>;
};

export type TeamEntityResponse = {
  __typename?: 'TeamEntityResponse';
  data?: Maybe<TeamEntity>;
};

export type TeamInput = {
  highlight?: InputMaybe<ComponentSectionMemberInput>;
  members?: InputMaybe<Array<InputMaybe<ComponentSectionMemberInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  ext?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['ID']>;
  folderPath?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  size?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  avatar?: Maybe<UploadFileEntityResponse>;
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  posts?: Maybe<PostRelationResponseCollection>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  username: Scalars['String'];
};


export type UsersPermissionsUserPostsArgs = {
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  posts?: InputMaybe<PostFiltersInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  avatar?: InputMaybe<Scalars['ID']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  posts?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type EventsCoreDataFragment = { __typename?: 'EventEntity', attributes?: { __typename?: 'Event', title?: string | null, description?: string | null, eventDate?: any | null, registerURL?: string | null, youtubeURL?: string | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null };

export type FaqCoreDataFragment = { __typename?: 'ComponentSectionFaqs', id: string, question?: string | null, answer?: string | null };

export type MemberCoreDataFragment = { __typename?: 'ComponentSectionMember', id: string, name: string, title: string, socials?: { __typename?: 'ComponentSectionSocial', twitter?: string | null, linkedin?: string | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null }, specialty?: { __typename?: 'ComponentSectionSpecialization', major: string, minor?: string | null } | null, certificates?: Array<{ __typename?: 'ComponentSharedCertificate', id: string, name: string, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null> | null };

export type PlanCoreDataFragment = { __typename?: 'ComponentSectionPlan', id: string, name: string, price: number, billingCycle: Enum_Componentsectionplan_Billingcycle, recommend?: boolean | null, features?: { __typename?: 'ComponentSectionFeature', LockInPeriodInMonths: number, FreeCoachingActivitiesAndWorksheets: boolean, ManagerSyncUpCall: Enum_Componentsectionfeature_Managersyncupcall, PulseSurvey: Enum_Componentsectionfeature_Pulsesurvey, FreeTrial: boolean } | null };

export type PostCoreDataFragment = { __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', slug: string, title: string, description?: string | null, content: string, views: any, estimatedReadingTime: number, publishedAt?: any | null, author?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', name?: string | null, email: string, username: string, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null } | null } | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null };

export type RequestCoreDataFragment = { __typename?: 'Request', name?: string | null, email: string, details?: any | null };

export type ResourceCoreDataFragment = { __typename?: 'ComponentSectionResourcePage', category?: string | null, description?: string | null, redirectURL?: string | null, price?: number | null, title?: string | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

export type ServiceCoreDataFragment = { __typename?: 'ComponentSectionServices', id: string, name: string, description?: string | null, learnMoreLink?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } };

export type SubscriberCoreDataFragment = { __typename: 'Subscriber', name?: string | null, email: string, company?: string | null, jobTitle?: string | null, details?: any | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null };

export type TestimonialCoreDataFragment = { __typename?: 'ComponentSectionTestimonial', id: string, author: string, feedback: string, rating: number, jobTitle?: string | null, company?: string | null, picture: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } };

export type UpdatePostMutationVariables = Exact<{
  id: Scalars['ID'];
  data: PostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost?: { __typename?: 'PostEntityResponse', data?: { __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', slug: string, title: string, description?: string | null, content: string, views: any, estimatedReadingTime: number, publishedAt?: any | null, author?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', name?: string | null, email: string, username: string, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null } | null } | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null } | null } | null };

export type CreateRequestMutationVariables = Exact<{
  data: RequestInput;
}>;


export type CreateRequestMutation = { __typename?: 'Mutation', createRequest?: { __typename?: 'RequestEntityResponse', data?: { __typename?: 'RequestEntity', id?: string | null, attributes?: { __typename?: 'Request', name?: string | null, email: string, details?: any | null } | null } | null } | null };

export type CreateSubscriberMutationVariables = Exact<{
  data: SubscriberInput;
}>;


export type CreateSubscriberMutation = { __typename?: 'Mutation', createSubscriber?: { __typename?: 'SubscriberEntityResponse', data?: { __typename: 'SubscriberEntity', id?: string | null, attributes?: { __typename: 'Subscriber', name?: string | null, email: string, company?: string | null, jobTitle?: string | null, details?: any | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null } | null } | null } | null };

export type UpdateSubscriberMutationVariables = Exact<{
  id: Scalars['ID'];
  data: SubscriberInput;
}>;


export type UpdateSubscriberMutation = { __typename?: 'Mutation', updateSubscriber?: { __typename?: 'SubscriberEntityResponse', data?: { __typename: 'SubscriberEntity', id?: string | null, attributes?: { __typename: 'Subscriber', name?: string | null, email: string, company?: string | null, jobTitle?: string | null, details?: any | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null } | null } | null } | null };

export type AnnouncementQueryVariables = Exact<{ [key: string]: never; }>;


export type AnnouncementQuery = { __typename?: 'Query', announcement?: { __typename?: 'AnnouncementEntityResponse', data?: { __typename?: 'AnnouncementEntity', id?: string | null, attributes?: { __typename?: 'Announcement', content?: string | null, redirectURL: string } | null } | null } | null };

export type EventsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  filters?: InputMaybe<EventFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type EventsQuery = { __typename?: 'Query', events?: { __typename?: 'EventEntityResponseCollection', data: Array<{ __typename?: 'EventEntity', attributes?: { __typename?: 'Event', title?: string | null, description?: string | null, eventDate?: any | null, registerURL?: string | null, youtubeURL?: string | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type LandingContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type LandingContentsQuery = { __typename?: 'Query', landing?: { __typename?: 'LandingEntityResponse', data?: { __typename?: 'LandingEntity', attributes?: { __typename?: 'Landing', faqs?: Array<{ __typename?: 'ComponentSectionFaqs', id: string, question?: string | null, answer?: string | null } | null> | null, services?: Array<{ __typename?: 'ComponentSectionServices', id: string, name: string, description?: string | null, learnMoreLink?: string | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } } | null> | null, testimonials?: Array<{ __typename?: 'ComponentSectionTestimonial', id: string, author: string, feedback: string, rating: number, jobTitle?: string | null, company?: string | null, picture: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } } | null> | null } | null } | null } | null };

export type PostsQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  filters?: InputMaybe<PostFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type PostsQuery = { __typename?: 'Query', posts?: { __typename?: 'PostEntityResponseCollection', data: Array<{ __typename?: 'PostEntity', id?: string | null, attributes?: { __typename?: 'Post', slug: string, title: string, description?: string | null, content: string, views: any, estimatedReadingTime: number, publishedAt?: any | null, author?: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', name?: string | null, email: string, username: string, avatar?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null } | null } | null, cover: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', width?: number | null, height?: number | null, url: string } | null } | null } } | null }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number, page: number, pageSize: number, pageCount: number } } } | null };

export type PricingContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PricingContentsQuery = { __typename?: 'Query', pricing?: { __typename?: 'PricingEntityResponse', data?: { __typename?: 'PricingEntity', attributes?: { __typename?: 'Pricing', plans?: Array<{ __typename?: 'ComponentSectionPlan', id: string, name: string, price: number, billingCycle: Enum_Componentsectionplan_Billingcycle, recommend?: boolean | null, features?: { __typename?: 'ComponentSectionFeature', LockInPeriodInMonths: number, FreeCoachingActivitiesAndWorksheets: boolean, ManagerSyncUpCall: Enum_Componentsectionfeature_Managersyncupcall, PulseSurvey: Enum_Componentsectionfeature_Pulsesurvey, FreeTrial: boolean } | null } | null> | null } | null } | null } | null };

export type ResourcesContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourcesContentsQuery = { __typename?: 'Query', resourcePage?: { __typename?: 'ResourcePageEntityResponse', data?: { __typename?: 'ResourcePageEntity', attributes?: { __typename?: 'ResourcePage', resources?: Array<{ __typename?: 'ComponentSectionResourcePage', category?: string | null, description?: string | null, redirectURL?: string | null, price?: number | null, title?: string | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null } | null } | null } | null };

export type SubscribersQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  filters?: InputMaybe<SubscriberFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
}>;


export type SubscribersQuery = { __typename?: 'Query', subscribers?: { __typename?: 'SubscriberEntityResponseCollection', data: Array<{ __typename?: 'SubscriberEntity', id?: string | null, attributes?: { __typename?: 'Subscriber', name?: string | null, email: string, company?: string | null, jobTitle?: string | null, details?: any | null, createdAt?: any | null, updatedAt?: any | null, publishedAt?: any | null } | null }> } | null };

export type TeamContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamContentsQuery = { __typename?: 'Query', team?: { __typename?: 'TeamEntityResponse', data?: { __typename?: 'TeamEntity', attributes?: { __typename?: 'Team', members?: Array<{ __typename?: 'ComponentSectionMember', id: string, name: string, title: string, socials?: { __typename?: 'ComponentSectionSocial', twitter?: string | null, linkedin?: string | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null }, specialty?: { __typename?: 'ComponentSectionSpecialization', major: string, minor?: string | null } | null, certificates?: Array<{ __typename?: 'ComponentSharedCertificate', id: string, name: string, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null> | null } | null> | null, highlight?: { __typename?: 'ComponentSectionMember', id: string, name: string, title: string, socials?: { __typename?: 'ComponentSectionSocial', twitter?: string | null, linkedin?: string | null } | null, photo: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null }, specialty?: { __typename?: 'ComponentSectionSpecialization', major: string, minor?: string | null } | null, certificates?: Array<{ __typename?: 'ComponentSharedCertificate', id: string, name: string, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, width?: number | null, height?: number | null } | null } | null } | null } | null> | null } | null } | null } | null } | null };

export const EventsCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EventsCoreData on EventEntity {
  attributes {
    thumbnail {
      data {
        attributes {
          url
          width
          height
        }
      }
    }
    title
    description
    eventDate
    registerURL
    youtubeURL
  }
}
    `;
export const FaqCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment FaqCoreData on ComponentSectionFaqs {
  id
  question
  answer
}
    `;
export const MemberCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment MemberCoreData on ComponentSectionMember {
  id
  name
  title
  socials {
    twitter
    linkedin
  }
  photo {
    data {
      attributes {
        url
        width
        height
      }
    }
  }
  specialty {
    major
    minor
  }
  certificates {
    id
    name
    description
    image {
      data {
        id
        attributes {
          url
          width
          height
        }
      }
    }
  }
}
    `;
export const PlanCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PlanCoreData on ComponentSectionPlan {
  id
  name
  price
  billingCycle
  recommend
  features {
    LockInPeriodInMonths
    FreeCoachingActivitiesAndWorksheets
    ManagerSyncUpCall
    PulseSurvey
    FreeTrial
  }
}
    `;
export const PostCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PostCoreData on PostEntity {
  id
  attributes {
    slug
    title
    description
    content
    author {
      data {
        id
        attributes {
          name
          email
          username
          avatar {
            data {
              attributes {
                url
                width
                height
              }
            }
          }
        }
      }
    }
    cover {
      data {
        attributes {
          width
          height
          url
        }
      }
    }
    views
    estimatedReadingTime
    publishedAt
  }
}
    `;
export const RequestCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment RequestCoreData on Request {
  name
  email
  details
}
    `;
export const ResourceCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ResourceCoreData on ComponentSectionResourcePage {
  category
  description
  redirectURL
  price
  thumbnail {
    data {
      attributes {
        url
      }
    }
  }
  title
}
    `;
export const ServiceCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment ServiceCoreData on ComponentSectionServices {
  id
  name
  description
  learnMoreLink
  cover {
    data {
      id
      attributes {
        url
        width
        height
      }
    }
  }
}
    `;
export const SubscriberCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SubscriberCoreData on Subscriber {
  name
  email
  company
  jobTitle
  details
  createdAt
  updatedAt
  publishedAt
  __typename
}
    `;
export const TestimonialCoreDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TestimonialCoreData on ComponentSectionTestimonial {
  id
  author
  feedback
  picture {
    data {
      id
      attributes {
        url
        width
        height
      }
    }
  }
  rating
  jobTitle
  company
}
    `;
export const UpdatePostDocument = /*#__PURE__*/ gql`
    mutation UpdatePost($id: ID!, $data: PostInput!) {
  updatePost(id: $id, data: $data) {
    data {
      ...PostCoreData
    }
  }
}
    ${PostCoreDataFragmentDoc}`;
export const CreateRequestDocument = /*#__PURE__*/ gql`
    mutation CreateRequest($data: RequestInput!) {
  createRequest(data: $data) {
    data {
      id
      attributes {
        ...RequestCoreData
      }
    }
  }
}
    ${RequestCoreDataFragmentDoc}`;
export const CreateSubscriberDocument = /*#__PURE__*/ gql`
    mutation CreateSubscriber($data: SubscriberInput!) {
  createSubscriber(data: $data) {
    data {
      id
      attributes {
        ...SubscriberCoreData
      }
      __typename
    }
  }
}
    ${SubscriberCoreDataFragmentDoc}`;
export const UpdateSubscriberDocument = /*#__PURE__*/ gql`
    mutation UpdateSubscriber($id: ID!, $data: SubscriberInput!) {
  updateSubscriber(id: $id, data: $data) {
    data {
      id
      attributes {
        ...SubscriberCoreData
      }
      __typename
    }
  }
}
    ${SubscriberCoreDataFragmentDoc}`;
export const AnnouncementDocument = /*#__PURE__*/ gql`
    query Announcement {
  announcement(publicationState: LIVE) {
    data {
      id
      attributes {
        content
        redirectURL
      }
    }
  }
}
    `;
export const EventsDocument = /*#__PURE__*/ gql`
    query Events($sort: [String], $filters: EventFiltersInput, $pagination: PaginationArg) {
  events(
    sort: $sort
    filters: $filters
    pagination: $pagination
    publicationState: LIVE
  ) {
    data {
      ...EventsCoreData
    }
    meta {
      pagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
}
    ${EventsCoreDataFragmentDoc}`;
export const LandingContentsDocument = /*#__PURE__*/ gql`
    query LandingContents {
  landing(publicationState: LIVE) {
    data {
      attributes {
        faqs {
          ...FaqCoreData
        }
        services {
          ...ServiceCoreData
        }
        testimonials {
          ...TestimonialCoreData
        }
      }
    }
  }
}
    ${FaqCoreDataFragmentDoc}
${ServiceCoreDataFragmentDoc}
${TestimonialCoreDataFragmentDoc}`;
export const PostsDocument = /*#__PURE__*/ gql`
    query Posts($sort: [String], $filters: PostFiltersInput, $pagination: PaginationArg) {
  posts(
    sort: $sort
    filters: $filters
    pagination: $pagination
    publicationState: LIVE
  ) {
    data {
      ...PostCoreData
    }
    meta {
      pagination {
        total
        page
        pageSize
        pageCount
      }
    }
  }
}
    ${PostCoreDataFragmentDoc}`;
export const PricingContentsDocument = /*#__PURE__*/ gql`
    query PricingContents {
  pricing {
    data {
      attributes {
        plans {
          ...PlanCoreData
        }
      }
    }
  }
}
    ${PlanCoreDataFragmentDoc}`;
export const ResourcesContentsDocument = /*#__PURE__*/ gql`
    query ResourcesContents {
  resourcePage(publicationState: LIVE) {
    data {
      attributes {
        resources {
          ...ResourceCoreData
        }
      }
    }
  }
}
    ${ResourceCoreDataFragmentDoc}`;
export const SubscribersDocument = /*#__PURE__*/ gql`
    query Subscribers($sort: [String], $filters: SubscriberFiltersInput, $pagination: PaginationArg) {
  subscribers(
    sort: $sort
    filters: $filters
    pagination: $pagination
    publicationState: LIVE
  ) {
    data {
      id
      attributes {
        name
        email
        company
        jobTitle
        details
        createdAt
        updatedAt
        publishedAt
      }
    }
  }
}
    `;
export const TeamContentsDocument = /*#__PURE__*/ gql`
    query TeamContents {
  team {
    data {
      attributes {
        members {
          ...MemberCoreData
        }
        highlight {
          ...MemberCoreData
        }
      }
    }
  }
}
    ${MemberCoreDataFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    UpdatePost(variables: UpdatePostMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePostMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePostMutation>(UpdatePostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePost', 'mutation');
    },
    CreateRequest(variables: CreateRequestMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateRequestMutation>(CreateRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateRequest', 'mutation');
    },
    CreateSubscriber(variables: CreateSubscriberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSubscriberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSubscriberMutation>(CreateSubscriberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSubscriber', 'mutation');
    },
    UpdateSubscriber(variables: UpdateSubscriberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSubscriberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSubscriberMutation>(UpdateSubscriberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateSubscriber', 'mutation');
    },
    Announcement(variables?: AnnouncementQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AnnouncementQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnnouncementQuery>(AnnouncementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Announcement', 'query');
    },
    Events(variables?: EventsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<EventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventsQuery>(EventsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Events', 'query');
    },
    LandingContents(variables?: LandingContentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LandingContentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LandingContentsQuery>(LandingContentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LandingContents', 'query');
    },
    Posts(variables?: PostsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PostsQuery>(PostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Posts', 'query');
    },
    PricingContents(variables?: PricingContentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PricingContentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PricingContentsQuery>(PricingContentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PricingContents', 'query');
    },
    ResourcesContents(variables?: ResourcesContentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<ResourcesContentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResourcesContentsQuery>(ResourcesContentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ResourcesContents', 'query');
    },
    Subscribers(variables?: SubscribersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SubscribersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscribersQuery>(SubscribersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Subscribers', 'query');
    },
    TeamContents(variables?: TeamContentsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TeamContentsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TeamContentsQuery>(TeamContentsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TeamContents', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;